import React from 'react'

const Button = ({title}) => {
  return (
    <button className='font-dm font-bold text-base text-white py-4 px-20 bg-primary'>{title}</button>
  )
}

export default Button